import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('submarine'),
  titleToNamespace: true,
  hasConnectionStatus: false,
  defaultAuthenticationType: 'bearer',
  avatarPath: avatars.submarine,
  logoPath: logos.submarine
});
